<div class="modal-overlay">
  <div class="modal-content">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">
      &times;
    </button>

    <div class="modal-body">
      <div class="modal-header">
        <h2>{{ mode === 'edit' ? ('flat.modalEditTitle' | t:'Edit Flat') : ('flat.modalNewTitle' | t:'New Flat') }}</h2>
      </div>

      <form class="flat-form" (ngSubmit)="submitForm()">
        <div class="form-layout">
          <div class="left-pane">
            <div class="form-group">
              <label>{{ 'flat.flatName' | t:'Flat Name' }} *</label>
              <input
                type="text"
                name="flatName"
                [(ngModel)]="flat.flatName"
                [placeholder]="'placeholder.typeFlatName' | t:'Type full name'"
                required
              />
            </div>

            <div class="form-row two-col">
              <div class="form-group">
                <app-common-dropdown
                  [dropdownObj]="houseDropdownObj"
                  [value]="flat.houseId"
                  (optionsLoaded)="onHouseOptionsLoaded($event)"
                  (valueChange)="onHouseDropdownChange($event)"
                ></app-common-dropdown>
              </div>

              <div class="form-group">
                <app-common-dropdown
                  [dropdownObj]="floorDropdownObj"
                  [value]="flat.floorName"
                  (valueChange)="onFloorDropdownChange($event)"
                ></app-common-dropdown>
              </div>
            </div>

            <div class="form-row two-col">
              <div class="form-group">
                <label>{{ 'flat.payDay' | t:'Pay Day' }} *</label>
                <div class="pay-day-scale-wrap">
                  <button type="button" class="scale-btn" (click)="decreasePayDay()">-</button>
                  <input
                    type="range"
                    name="payDayTh"
                    [(ngModel)]="flat.payDayTh"
                    [min]="payDayMin"
                    [max]="payDayMax"
                    step="1"
                    (input)="onPayDayInput()"
                    required
                  />
                  <button type="button" class="scale-btn" (click)="increasePayDay()">+</button>
                </div>
                <div class="pay-day-scale-value">{{ flat.payDayTh }} {{ 'flat.dayOfMonth' | t:'day of month' }}</div>
              </div>

              <div class="form-group">
                <label>{{ 'flat.flatRentAmount' | t:'Flat Rent Amount' }} *</label>
                <input
                  type="number"
                  min="0"
                  name="rentAmount"
                  [(ngModel)]="flat.rentAmount"
                  [placeholder]="'placeholder.typeFlatRentAmount' | t:'Type flat rent amount'"
                  required
                />
              </div>
            </div>
          </div>

          <div class="right-pane">
            <div class="form-group">
              <label>{{ 'flat.paymentStyle' | t:'Payment Style' }} *</label>
              <div class="radio-group">
                <label class="radio-item">
                  <input type="radio" name="paymentStyle" [value]="'after'" [(ngModel)]="flat.paymentStyle" />
                  <span>{{ 'flat.afterMonth' | t:'After Month' }}</span>
                </label>
                <label class="radio-item">
                  <input type="radio" name="paymentStyle" [value]="'running'" [(ngModel)]="flat.paymentStyle" />
                  <span>{{ 'flat.runningMonth' | t:'Running Month' }}</span>
                </label>
              </div>
            </div>

            <div class="form-group">
              <label>{{ 'flat.appliedBills' | t:'Applied Bills' }} *</label>

              <div class="bill-row">
                <label class="check-item">
                  <input type="checkbox" name="gasBillRequired" [(ngModel)]="flat.gasBillRequired" (change)="toggleBillAmount('gas')" />
                  <span>{{ 'flat.gas' | t:'Gas' }}</span>
                </label>
                <input *ngIf="flat.gasBillRequired" type="number" min="0" name="gasBillAmount" [(ngModel)]="flat.gasBillAmount" [placeholder]="'flat.optionalAmount' | t:'Type amount here (optional)'" />
              </div>

              <div class="bill-row">
                <label class="check-item">
                  <input type="checkbox" name="waterBillRequired" [(ngModel)]="flat.waterBillRequired" (change)="toggleBillAmount('water')" />
                  <span>{{ 'flat.water' | t:'Water' }}</span>
                </label>
                <input *ngIf="flat.waterBillRequired" type="number" min="0" name="waterBillAmount" [(ngModel)]="flat.waterBillAmount" [placeholder]="'flat.optionalAmount' | t:'Type amount here (optional)'" />
              </div>

              <div class="bill-row">
                <label class="check-item">
                  <input type="checkbox" name="electricBillRequired" [(ngModel)]="flat.electricBillRequired" (change)="toggleBillAmount('electric')" />
                  <span>{{ 'flat.electric' | t:'Electric' }}</span>
                </label>
                <input *ngIf="flat.electricBillRequired" type="number" min="0" name="electricBillAmount" [(ngModel)]="flat.electricBillAmount" [placeholder]="'flat.optionalAmount' | t:'Type amount here (optional)'" />
              </div>

              <div class="bill-row">
                <label class="check-item">
                  <input type="checkbox" name="serviceChargeAndOtherRequired" [(ngModel)]="flat.serviceChargeAndOtherRequired" (change)="toggleBillAmount('service')" />
                  <span>{{ 'flat.serviceChargeOther' | t:'Service Charge + Other' }}</span>
                </label>
                <input *ngIf="flat.serviceChargeAndOtherRequired" type="number" min="0" name="serviceChargeAndOtherAmount" [(ngModel)]="flat.serviceChargeAndOtherAmount" [placeholder]="'flat.optionalAmount' | t:'Type amount here (optional)'" />
              </div>

              <div class="bill-row">
                <label class="check-item">
                  <input type="checkbox" name="negativeChargeRequired" [(ngModel)]="flat.negativeChargeRequired" (change)="toggleBillAmount('other')" />
                  <span>{{ 'flat.negativeCharge' | t:'Negative Charge' }}</span>
                </label>
                <input *ngIf="flat.negativeChargeRequired" type="number" min="0" name="negativeChargeAmount" [(ngModel)]="flat.negativeChargeAmount" [placeholder]="'flat.optionalAmount' | t:'Type amount here (optional)'" />
              </div>

              <input
                *ngIf="flat.negativeChargeRequired"
                type="text"
                name="negativeChargeName"
                [(ngModel)]="flat.negativeChargeName"
                maxlength="20"
                [placeholder]="'placeholder.typeNegativeChargeName' | t:'Negative charge name'"
              />
            </div>
          </div>
        </div>

        <div class="form-actions">
          <div class="form-message error" *ngIf="error">{{ error }}</div>
          <button class="PositiveBTN" type="submit" [disabled]="isSubmitting">
            {{ isSubmitting ? ('common.saving' | t:'Saving...') : (mode === 'edit' ? ('flat.updateButton' | t:'Update Flat') : ('flat.addButton' | t:'Add Flat')) }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

